import api from "../../../../lib/api";
import { Input } from "../../../../components/ui/input";
import { toast } from "sonner";

/**
 * RowTagDialog — small modal spawned by the row-level "Add tag…" action.
 * Persists via POST /dropship/orders/tags {order_ids, add}.
 */
export default function RowTagDialog({
  rowTagOid, setRowTagOid,
  rowTagText, setRowTagText,
  setRowActionBusy, reload,
}) {
  if (!rowTagOid) return null;

  const save = async () => {
    if (!rowTagText.trim()) return;
    setRowActionBusy(true);
    try {
      await api.post("/dropship/orders/tags", {
        order_ids: [rowTagOid],
        add: rowTagText.split(",").map(s => s.trim()).filter(Boolean),
      });
      toast.success("Tag added");
      setRowTagOid(null); reload();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Tag failed");
    } finally { setRowActionBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-6" onClick={() => setRowTagOid(null)}>
      <div className="bg-white rounded-2xl max-w-sm w-full p-5 space-y-3" onClick={e => e.stopPropagation()} data-testid="row-tag-dialog">
        <div className="text-[14px] font-semibold">Add tag</div>
        <Input value={rowTagText} onChange={e => setRowTagText(e.target.value)}
          placeholder="e.g. vip, heavy, weekend"
          className="h-10 mono" data-testid="row-tag-input" autoFocus/>
        <div className="flex justify-end gap-2">
          <button onClick={() => setRowTagOid(null)}
            className="text-[11.5px] mono uppercase tracking-[0.14em] rounded-full h-9 px-4 border border-border hover:bg-secondary">
            Cancel
          </button>
          <button
            onClick={save}
            data-testid="row-tag-save"
            className="text-[11.5px] mono uppercase tracking-[0.14em] rounded-full h-9 px-4 bg-foreground text-background hover:bg-foreground/90">
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
